
import { toastSucesso } from './utilidades/toastSucesso';
import { toastErroCarregar } from './utilidades/toastErroCarregar';
import { getFetch } from './utilidades/getFetch';
import { postFetch } from './utilidades/postFetch';
import { obterQueryString } from './utilidades/obterQueryString';
import { obterOrigem } from './utilidades/obterOrigem';
import { obterDispositivo } from './utilidades/obterDispositivo';
import { loadFullPage } from './utilidades/loadFullPage';
import { obterCookie } from './utilidades/obterCookie';
import { isNullOrEmpty } from './utilidades/isNullOrEmpty';
import { salvarCookie } from './utilidades/salvarCookie';
import { inicializarInternacionalizacao } from './localizacao/vagas-detalhes/vagas-detalhes';
import { addTrack, trackConversaoCandidaturaVaga } from './utilidades/trackEventos';
import { salvarCandidaturaPendente, removerCandidaturaPendente } from './utilidades/candidaturaPendente';

import { Confirm } from 'notiflix/build/notiflix-confirm-aio';
import { Report } from 'notiflix/build/notiflix-report-aio';
import { AlertaVaga } from './utilidades/alertaVaga';
import { templateCardAlertaVagas } from './componentes/alertaVagas/templatesAlertaVaga';

import i18next from 'i18next';

import { localBanner, banner } from './utilidades/banner'
import { templateCardInfoFanpage } from './componentes/fanPage/templateCardFanPage';


const vagaDetalhes = function () {

    const nomeEmpresa = document.getElementById("nomeEmpresa").value;
    const vagaID = document.getElementById('VagaID').value;
    const vagaTitulo = document.getElementById('VagaTitulo').value;
    const vagaCidadesSeparadas = document.getElementById('VagaCidadesSeparadas').value;
    const vagaCidadesSeparadasVirgula = document.getElementById('VagaCidadesSeparadasVirgula').value;
    const vagaCargo = document.getElementById('VagaCargo').value;
    const vagaUrl = document.getElementById('VagaURL').value;
    const variasCidades = document.getElementById('VariasCidades') ? document.getElementById('VariasCidades').value == 'True' : false;
    const containerInscrevase = document.getElementById('container-candidatar');
    const containerInscrevaseStick = document.getElementById('container-candidatar-stick');
    let observerStickyTopScrollDetalhesVaga = null;
    let validatorDenuncia = null;
    const tipoProcessoSeletivo = document.getElementById('TipoProcessoSeletivo').value;
    const empresaID = document.getElementById("EmpresaID").value;

    const _modalCompartilharCopiarLink = function () {
        const textoLinkVaga = document.querySelector('.texto-link-vaga');
        const btnCopiarLinkVaga = document.querySelector('.btn-copiar-link-vaga');

        function _copiarLink() {
            navigator.clipboard
                .writeText(textoLinkVaga.innerText)
                .then(() => {
                    toastSucesso(i18next.t('ModalCompartilharLinkVagaCopiado'));
                })
                .catch(() => {
                    toastErroCarregar(i18next.t('ModalCompartilharErroCopiarLink'));
                });
        }
        btnCopiarLinkVaga.addEventListener('click', () => _copiarLink());
        textoLinkVaga.addEventListener('click', () => _copiarLink());
    };
    const _modalCompartilhar = function () {

        if (navigator.share && obterDispositivo() != "Desktop") {
            navigator.share({
                title: `Empregare.com - ${document.getElementById('VagaTitulo').value}`,
                url: vagaUrl
            }).then(() => {

            }).catch((erro) => {
                console.log('Erro navigator share: ');
                console.log(erro);
            });


        } else {
            const $modalCompartilhar = new bootstrap.Modal(document.getElementById('modalDivulgacao'), {});
            $modalCompartilhar.show();


        }
        addTrack('Compartilhar Vaga', { vagaID: vagaID });

    };

    const _modalDenunciar = async function () {
        // Carrega as dependências somente quando a função é chamada
        const { default: JustValidate } = await import('just-validate');
        const { default: intlTelInput } = await import('intl-tel-input');
        const { getGeoData } = await import('./utilidades/geoData');

        const cssUrl = `/assetsV2/common/css/contato.min.css`;

        if (!document.querySelector(`link[href="${cssUrl}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssUrl;
            document.head.appendChild(link);
        }

        const modalDenunciarEl = document.getElementById('modalDenunciar');
        if (!modalDenunciarEl) {
            console.error('Elemento do modal #modalDenunciar não encontrado.');
            return;
        }
        const form = modalDenunciarEl.querySelector("#form-denunciar");
        const telefoneInput = form.querySelector("#telefone");
        const emailInput = form.querySelector("#email");

        const modalInstance = bootstrap.Modal.getOrCreateInstance(modalDenunciarEl);

        if (!validatorDenuncia) {

            validatorDenuncia = new JustValidate('#form-denunciar', {
                errorFieldCssClass: 'is-invalid'

            });

            validatorDenuncia
                .addField('#email', [{ rule: 'required', errorMessage: i18next.t('DenunciaEmailObrigatorio') }, { rule: 'email', errorMessage: 'E-mail inválido' }])
                .addField('#denunciaMotivo', [{ rule: 'required', errorMessage: i18next.t('DenunciaMotivoObrigatorio') }])
                .addField('#denunciaObservacao', [{ rule: 'required', errorMessage: i18next.t('DenunciaObservacaoObrigatorio') }, { rule: 'minLength', value: 20, errorMessage: i18next.t('DenunciaObservacaoTamanhoMinimo') }])
                .onSuccess((event) => {
                    // 1. Impede o envio padrão do formulário
                    event.preventDefault();

                    // 2. Executa a lógica de envio que estava em _configurarFormularioDenuncia
                    loadFullPage.mostrar();

                    const formData = new FormData(form);
                    formData.append('VagaID', vagaID);
                    formData.append('VagaUrl', vagaUrl);

                    const url = form.action;

                    const callbackDenunciaSucesso = (data) => {
                        if (data.sucesso) {
                            form.reset();
                            toastSucesso(data.mensagem);
                        }

                        modalInstance.hide();
                        loadFullPage.esconder();
                    };

                    const callbackDenunciaErro = (erro) => {
                        const mensagemErro = erro.mensagem || "Ocorreu um erro inesperado.";
                        toastErroCarregar(mensagemErro);
                    };



                    postFetch(url, formData, callbackDenunciaSucesso, callbackDenunciaErro, callbackDenunciaErro, true, false);
                });

        }

        modalInstance.show();


        const callbackSucesso = (data) => {
            const intlOptions = {
                preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
                dropdownContainer: form.querySelector("#form-body"),
                customContainer: "d-block",
                utilsScript: "/assetsV2/lib/intl-tel-util/utils.js",
            };

            const iti = intlTelInput(telefoneInput, intlOptions);

            if (data.logado) {
                const telefoneCelularPaisCode = data.pessoa.CelularPaisCode ?? data.pessoa.TelefonePaisCode;
                const telefoneCelular = data.pessoa.Celular ?? data.pessoa.Telefone;

                emailInput.value = data.pessoa.Email || '';

                iti.setNumber(telefoneCelularPaisCode || '');
                telefoneInput.value = telefoneCelular || '';
            }
        };

        const callbackErro = () => {
            const geoData = getGeoData();
            const paisID = (geoData.existe && geoData.data.pais) ? geoData.data.pais : 'BR';
            intlTelInput(telefoneInput, {
                initialCountry: paisID.toLowerCase(),
                preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
                dropdownContainer: form.querySelector("#form-body"),
                customContainer: "d-block",
                utilsScript: "/assetsV2/lib/intl-tel-util/utils.js",
            });
        }

        getFetch(
            `/${CULTURE_EMPREGARE}/PaginasEstaticas/GetDetalhesPessoa`,
            callbackSucesso,
            callbackErro,
            null
        );
    };

    const _modalSelecaoCega = function (tab) {
        document.querySelector('#tabsInfoSelecaoCega button[data-bs-target="' + tab + '"]').dispatchEvent(new Event('click'));
    };
    const _modalCandidatarLogin = function () {
        const $modalCandidatar = bootstrap.Modal.getInstance(document.getElementById('modal-candidatar'));
        $modalCandidatar.hide();

        document.querySelector('.btn-login').click();

        //document.getElementById('load-form-login').classList.remove('d-none');
        //document.getElementById('box-mostrar-login').classList.add('d-none');
    };

    const _modalCandidatarBot = async function () {


        const dispositivo = obterDispositivo();
        if (dispositivo == 'Desktop') {

            const $modalCandidatarBot = new bootstrap.Modal(document.getElementById('modal-candidatura-whatsapp'), {});


            const { default: qrcode } = await import('qrcode-generator');

            let urlVagaCurta = document.getElementById('VagaURLCurta').value;

            urlVagaCurta = urlVagaCurta.replace('/v', '/whatsapp/')
            var typeNumber = 4;
            var errorCorrectionLevel = 'L';
            var qr = qrcode(typeNumber, errorCorrectionLevel);
            qr.addData(urlVagaCurta);
            qr.make();
            document.getElementById('qrcode-container').innerHTML = qr.createImgTag();

            $modalCandidatarBot.show();
        } else {
            _confirmarCandidaturaBot();
        }
    };

    const _insights = async function (pessoaID) {

        if (obterQueryString().confirmar === '1') {
            return;
        }
        let formData = new FormData();
        formData.append('vagaID', vagaID);
        formData.append('origem', obterOrigem());
        formData.append('pessoaID', pessoaID);
        formData.append('url', window.location.hostname);
        formData.append('dispositivo', obterDispositivo());

        await fetch(`/${CULTURE_EMPREGARE}/Vagas/SalvarVisualizacao`, {
            method: 'POST',
            body: formData
        });

        //addTrack('Visualizar Vaga', { vagaID: vagaID, referer: obterOrigem(), origem: obterCookie('origemCadastro') });
    };

    const _cancelarCandidatura = async function (candidaturaID, motivoID, justificativa) {
        loadFullPage.mostrar();

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            if (resultado && resultado.sucesso === false) {
                Report.failure('Erro', resultado.mensagem || 'Erro ao cancelar candidatura.', 'OK');
                return;
            }

            Report.success(
                i18next.t('CancelarCandidaturaSucesso'),
                '',
                i18next.t('ReportOk'),
                () => {
                    loadFullPage.mostrar();
                    window.location.reload();
                }
            );
        };
        const callbackErro = () => {
            loadFullPage.esconder();
        };

        let formData = new FormData();
        formData.append('id', candidaturaID);
        if (motivoID)
            formData.append('motivoID', motivoID);

        if (justificativa)
            formData.append('justificativa', justificativa);

        await postFetch(`/${CULTURE_EMPREGARE}/PainelCandidaturas/ConfirmarCancelamento`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _confirmarCandidatura = async function () {
        loadFullPage.mostrar();
        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            if (resultado.id > 0) {
                trackConversaoCandidaturaVaga();
                removerCandidaturaPendente(false);

                const $modalConfirmarCandidatura = bootstrap.Modal.getInstance(document.getElementById('modal-confirmar-candidatura'));

                if ($modalConfirmarCandidatura) {
                    $modalConfirmarCandidatura.hide();
                }


                if (resultado.questionarioRespostaTriagem != 0) {
                    Report.success(
                        i18next.t('ConfirmarCandidaturaSucesso'),
                        i18next.t('ConfirmarCandidaturaQuestionario'),
                        i18next.t('ConfirmarCandidaturaResponderQuestionario'),
                        () => {
                            loadFullPage.mostrar();
                            window.location.href = `/${CULTURE_EMPREGARE}/candidato/questionario/${resultado.questionarioRespostaTriagem}_${resultado.id}?ocultaOrientacoes=true`;
                        }
                    );
                }
                else if (resultado.questionario) {
                    Report.success(
                        i18next.t('ConfirmarCandidaturaSucesso'),
                        i18next.t('ConfirmarCandidaturaQuestionario'),
                        i18next.t('ConfirmarCandidaturaResponderQuestionario'),
                        () => {
                            loadFullPage.mostrar();
                            window.location.href = `/${CULTURE_EMPREGARE}/candidato/questionarios/${vagaID}_${resultado.id}?inscricao=${vagaID}`;
                        }
                    );
                }
                else {

                    _botaoCandidatar();

                    Report.success(
                        i18next.t('ConfirmarCandidaturaSucesso'),
                        i18next.t('ConfirmarCandidaturaInscricaoRealizada'),
                        i18next.t('ReportOk'),
                        () => {

                        }
                    );
                }

            } else {
                if (resultado.retorno === 'CidadeNaoSelecionada') {
                    Report.warning(
                        i18next.t('CidadeNaoSelecionadaAtencao'),
                        resultado.retornoMensagem,
                        i18next.t('ReportOk'),
                    );
                } else {
                    const $modalConfirmarCandidatura = bootstrap.Modal.getInstance(document.getElementById('modal-confirmar-candidatura'));
                    if ($modalConfirmarCandidatura) {
                        $modalConfirmarCandidatura.hide();
                    }
                    _montaBotaoCandidatar(resultado);
                }
            }
        }
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
        }

        const source = obterCookie('origemCadastro');
        const origem = obterOrigem();
        const dispositivo = obterDispositivo();

        let formData = new FormData(document.getElementById('form-confirmar-inscricao'));
        formData.append('id', vagaID);
        formData.append('source', source);
        formData.append('referer', origem);
        formData.append('dispositivo', dispositivo);

        await postFetch(`/${CULTURE_EMPREGARE}/Vagas/ConfirmarCandidatura`, formData, callbackSucesso, callbackErro, callbackErro);

    };
    const _confirmarCandidaturaBot = async function () {
        //loadFullPage.mostrar();

        window.location.href = `/whatsapp/${vagaID}`;

    };
    const _redirecionarNovoCadastro = function () {
        loadFullPage.mostrar();
        window.location.href = `/${CULTURE_EMPREGARE}/cadastrar-curriculo`;

    };


    const _montaBotaoCandidatar = (resultado) => {
        let gatilho = '';
        let botaoCandidatarHtml = '';

        if (!isNullOrEmpty(resultado.gatilho.titulo)) {
            gatilho = `<small class="gatilho-mental p-3 text-muted">${resultado.gatilho.icone} ${resultado.gatilho.titulo}</small>`;
        }

        const urlVincularMatricula = `/${CULTURE_EMPREGARE}/candidato/matricula?ReturnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;

        switch (resultado.retorno) {
            case "VagaEncerrada":
                containerInscrevase.parentNode.classList.remove("alert", "alert-secondary");
                containerInscrevase.innerHTML = `<div class="alert alert-danger mb-0">
                        <h5>${i18next.t('VagaEncerradaNaoRecebeCurriculos')}</h5>
                        <p class="mt-3 mb-0">${i18next.t('VagaEncerradaPossiveisMotivos')}</p>
                        <ul class="mb-0">
                            <li>${i18next.t('VagaEncerradaFechadaOuEncerrada')}</li>
                            <li>${i18next.t('VagaEncerradaAtingiuDataExpiracao')}</li>
                            <li>${i18next.t('VagaEncerradaVagaCancelada')}</li>
                        </ul>
                    </div>`;
                const btnModalCompartilhar = document.querySelectorAll('.btn-abrir-modal-divulgacao');
                btnModalCompartilhar.forEach(el => el.classList.add('d-none'));

                removerCandidaturaPendente(false);
                document.getElementById('VagaStatus').value = resultado.retorno;
                document.getElementById('navbarFixadaDetalheVaga').classList.add('d-none');
                if (observerStickyTopScrollDetalhesVaga != null) {
                    observerStickyTopScrollDetalhesVaga.disconnect();
                }

                return;
            case "NaoLogado":

                if (resultado.aceitarCandidaturaBot) {
                    // text-white anulava o color-contrast do Bootstrap (3,30:1); sem ela o .btn-success usa preto = 6,35:1
                    botaoCandidatarHtml = `<button type="button" title="Candidate-se pelo WhatsApp" class="btn btn-success btn-fullwidth-mobile btn-candidatarse-whatsapp"><i class="bi bi-whatsapp"></i> Candidate-se pelo WhatsApp</button> <button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-outline-primary btn-fullwidth-mobile btn-candidatarse btn-hideStickTop"><i class="bi bi-clipboard-check"></i> Candidate-se pela Empregare</button>${gatilho}`;
                }
                else {

                    botaoCandidatarHtml = `<button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-primary btn-fullwidth-mobile btn-candidatarse"><i class="bi bi-clipboard-check"></i> ${i18next.t('BotaoCandidatarSe')}</button>${gatilho}`;
                }
                containerInscrevase.innerHTML = botaoCandidatarHtml;

                document.querySelectorAll('.btn-candidatarse').forEach(el => el.addEventListener('click', () => {
                    _eventListnerBotaoCandidatarNaoLogado();
                }));


                if (resultado.aceitarCandidaturaBot) {
                    document.querySelectorAll('.btn-candidatarse-whatsapp').forEach(el => el.addEventListener('click', () => {
                        _eventListnerBotaoCandidatarWhatsApp();
                    }));
                }
                _stickyTopScrollDetalhesVaga(containerInscrevase, containerInscrevaseStick, 'NaoLogado');
                return;
            case "CurriculoIncompleto":
                containerInscrevase.parentNode.classList.remove("alert", "alert-secondary");
                containerInscrevase.innerHTML = `<div class="alert alert-warning mb-0">
                        <h5>${i18next.t('CurriculoIncompleto')}</h5>
                        <p class="mb-1">${i18next.t('CurriculoIncompletoTexto')}</p>
                        <p class="mb-1">${i18next.t('CurriculoIncompletoEfetueMudancas')}</p>
                        <button type="button" class="btn btn-warning btn-curriculo-incompleto"><i class="bi bi-file-earmark-text" aria-hidden="true"></i> ${i18next.t('CurriculoIncompletoBotao')}</button>
                    </div>`;
                if (containerInscrevase.querySelector('.btn-curriculo-incompleto') != undefined) {
                    containerInscrevase.querySelector('.btn-curriculo-incompleto').addEventListener('click', async (e) => {
                        loadFullPage.mostrar();
                        await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
                        window.location.href = `/${CULTURE_EMPREGARE}/candidato/curriculo-incompleto`;
                    });
                }
                return;
            case "CurriculoNaoPermitido":
            case "CurriculoNaoExiste":
            case "LimiteUltrapassado":
            case "SomenteColaboradores":
            case "SomenteColaboradoresDaEmpresa":
            case "SomenteCandidatos":
            case "DeficienciaObrigatoria":
            case "AlunoNaoEncontrado":
            case "AlunoExAluno":

                var mensagem = resultado.retornoMensagem;
                if (nomeEmpresa) {
                    mensagem = mensagem.replace("##nomeEmpresa##", nomeEmpresa);
                } else {
                    // Se o ##nomeEmpresa## n�o existir, fazer a substitui��o por uma string vazia
                    mensagem = mensagem.replace("##nomeEmpresa##", "");
                }
                // Matricula nao encontrada pode ser digitacao errada: o aluno corrige sem depender da instituicao.
                var linkMatricula = resultado.retorno === 'AlunoNaoEncontrado'
                    ? `<a class="btn btn-warning btn-sm text-light" href="${urlVincularMatricula}">${i18next.t('AlunoVincularMatricula')}</a>`
                    : '';
                containerInscrevase.parentNode.classList.remove("alert", "alert-secondary");
                containerInscrevase.innerHTML = `<div class="alert alert-warning mb-0">
                        <h5><i class="bi bi-exclamation-circle"></i> ${i18next.t('AlunoCandidaturaBloqueada')}</h5>
                        <p>${mensagem}</p>${linkMatricula}
                    </div>`;

                removerCandidaturaPendente(false);
                document.getElementById('VagaStatus').value = resultado.retorno;
                return;
            case "Inscrito":
                containerInscrevase.innerHTML = `
                        <div class="row"><div class="col-12 text-center"><p class="mb-3"><b class="text-success"><i class="bi bi-check2-circle"></i> ${i18next.t('InscritoJaCandidatado')}</b></p>
                        
                        <a href="/${CULTURE_EMPREGARE}/candidato/inscricao_${resultado.id}" class="btn btn-primary mb-3 btn-fullwidth-mobile">${i18next.t('ConfirmarCandidaturaVisualizarCandidatura')}</a>
                        <button type="button" class="btn btn-outline-danger btn-cancelar mb-3 btn-fullwidth-mobile" data-id="${resultado.id}">${i18next.t('CancelarCandidatura')}</button>
                </div>`;

                containerInscrevase.querySelector('.btn-cancelar').addEventListener('click', async (e) => {
                    const candidaturaID = e.target.getAttribute('data-id');

                    let resultado;
                    try {
                        const response = await fetch(`/${CULTURE_EMPREGARE}/PainelCandidaturas/ObterMotivosCancelamento?candidaturaId=${candidaturaID}`);
                        resultado = await response.json();
                    } catch {
                        return;
                    }

                    if (!resultado.sucesso) return;

                    if (resultado.bypass) {
                        Confirm.show(
                            i18next.t('CancelarCandidatura'),
                            i18next.t('CancelarCandidaturaTexto'),
                            i18next.t('CancelarCandidaturaConfirmar'),
                            i18next.t('CancelarCandidaturaCancelar'),
                            () => { _cancelarCandidatura(candidaturaID); },
                            () => { }
                        );
                    } else {
                        const modal = document.getElementById('modal-cancelamento');
                        const selectMotivo = modal.querySelector('#select-motivo');
                        const lblObrigatorio = modal.querySelector('#motivo-obrigatorio-label');

                        selectMotivo.innerHTML = `<option value="">${i18next.t('SelecteMotivoPlaceholder')}</option>`;
                        resultado.motivos.forEach(m => {
                            const opt = document.createElement('option');
                            opt.value = m.ID;
                            opt.textContent = m.Descricao;
                            selectMotivo.appendChild(opt);
                        });

                        if (resultado.obrigatorio) {
                            lblObrigatorio.classList.remove('d-none');
                            selectMotivo.setAttribute('required', 'required');
                        } else {
                            lblObrigatorio.classList.add('d-none');
                            selectMotivo.removeAttribute('required');
                        }

                        modal.querySelector('#textarea-justificativa').value = '';

                        const bsModal = new bootstrap.Modal(modal);
                        bsModal.show();

                        const btnConfirmar = modal.querySelector('#btn-confirmar-cancelamento');
                        const novoBtn = btnConfirmar.cloneNode(true);
                        btnConfirmar.parentNode.replaceChild(novoBtn, btnConfirmar);

                        novoBtn.addEventListener('click', async () => {
                            const motivoSelecionado = selectMotivo.value;
                            const textarea = modal.querySelector('#textarea-justificativa');
                            const justificativa = textarea.value.trim();

                            if (!motivoSelecionado && (resultado.obrigatorio || justificativa)) {
                                selectMotivo.classList.add('is-invalid');
                                return;
                            }
                            selectMotivo.classList.remove('is-invalid');

                            const tmpDiv = document.createElement('div');
                            tmpDiv.innerHTML = justificativa;
                            const justificativaLimpa = (tmpDiv.textContent || tmpDiv.innerText || '').substring(0, 200);

                            bsModal.hide();
                            await _cancelarCandidatura(candidaturaID, motivoSelecionado || null, justificativaLimpa || null);
                        });
                    }
                });

                removerCandidaturaPendente(false);
                document.getElementById('VagaStatus').value = resultado.retorno;
                return;
            case "Liberado":
            case "Cancelado":
                if (obterQueryString().confirmar == '1') {
                    const $modalConfirmarCandidatura = new bootstrap.Modal(document.getElementById('modal-confirmar-candidatura'), {});
                    $modalConfirmarCandidatura.show();
                }
                if (variasCidades) {

                    botaoCandidatarHtml = `<button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-primary btn-fullwidth-mobile btn-candidatarse" data-bs-target="#modal-confirmar-candidatura" data-bs-toggle="modal"><i class="bi bi-clipboard-check"></i> ${i18next.t('BotaoCandidatarSe')}</button>${gatilho}`;
                    containerInscrevase.innerHTML = botaoCandidatarHtml;

                    const btnCandidatar = document.querySelectorAll('.btn-candidatarse');

                    btnCandidatar.forEach(el => el.addEventListener('click', async () => {
                        await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
                        addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
                    }));

                } else {
                    botaoCandidatarHtml = `<button type="button" title="${i18next.t('BotaoCandidatarSeVaga')}" class="btn btn-primary btn-fullwidth-mobile btn-candidatarse"><i class="bi bi-clipboard-check"></i> ${i18next.t('BotaoCandidatarSe')}</button>${gatilho}`;
                    containerInscrevase.innerHTML = botaoCandidatarHtml;

                    const btnCandidatar = document.querySelectorAll('.btn-candidatarse');

                    btnCandidatar.forEach(el => el.addEventListener('click', async () => {
                        _confirmarCandidatura();
                    }));
                }
                _stickyTopScrollDetalhesVaga(containerInscrevase, containerInscrevaseStick, 'Logado');
                return;
            case "AlunoSemMatricula":
                containerInscrevase.parentNode.classList.remove("alert", "alert-secondary");
                containerInscrevase.innerHTML = `<div class="alert alert-warning mb-0">
                        <h5><i class="bi bi-exclamation-circle"></i> ${i18next.t('AlunoCandidaturaBloqueada')}</h5>
                        <p class="mb-1">${resultado.retornoMensagem}</p>
                        <a class="btn btn-warning btn-sm text-light" href="${urlVincularMatricula}">${i18next.t('AlunoVincularMatricula')}</a>
                    </div>`;
                return;
            case "Erro":
                containerInscrevase.parentNode.classList.remove("alert", "alert-secondary");
                containerInscrevase.innerHTML = `<div class="alert alert-danger mb-0">
                        <h5>${i18next.t('ErroCandidatarVagaTitulo')}</h5>
                        <p class="mb-1">${i18next.t('ErroCandidatarVagaTexto')}</p>
                        <a href="#" onclick="window.location.reload();" class="btn btn-danger text-light">${i18next.t('ErroCandidatarVagaRecarregar')}</a>
                    </div>`;

                return;
            default:
                return;
        }
    };
    const _botaoCandidatar = async function () {
        containerInscrevaseStick.innerHTML = '';
        document.getElementById('navbarFixadaDetalheVaga').classList.add('d-none');
        const callbackSucesso = (resultado) => {
            _montaBotaoCandidatar(resultado);
            if (resultado.retorno != 'VagaEncerrada' && resultado.retorno != 'Inscrito') {
                _insights(resultado.pessoaID);
            }
        }
        const callbackErro = () => {
            containerInscrevase.parentNode.classList.remove("alert", "alert-secondary");
            containerInscrevase.innerHTML = `<div class="alert alert-danger mb-0">
                        <h5>${i18next.t('ErroCandidatarVagaTitulo')}</h5>
                        <p class="mt-3">${i18next.t('ErroCandidatarVagaTexto')}</p>
                        <a href="#" onclick="window.location.reload();" class="btn btn-danger text-light"><i class="bi bi-arrow-clockwise"></i> ${i18next.t('ErroCandidatarVagaRecarregar')}</a>
                    </div>`;
        }

        await getFetch(`/${CULTURE_EMPREGARE}/Vagas/BotaoCandidatar/${vagaID}`, callbackSucesso, callbackErro, callbackErro);
    };

    const _eventListnerBotaoCandidatarNaoLogado = async function () {
        document.querySelector('.btn-login').click();
        addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
        salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, false);
    }
    const _eventListnerBotaoCandidatarWhatsApp = async function () {
        salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, false);
        _modalCandidatarBot();
    }

    const _definirOrigemCadastro = async function () {
        let source = '';

        source = obterQueryString().campanha;
        if (isNullOrEmpty(source)) {
            source = obterQueryString().source;
        }
        if (isNullOrEmpty(source)) {
            return;
        }
        salvarCookie('origemCadastro', source, 1);
    };

    const _stickyTopScrollDetalhesVaga = (containerInscrevase, containerInscrevaseStick, eventListner) => {
        const navbarFixadaDetalheVaga = document.getElementById('navbarFixadaDetalheVaga');

        if (observerStickyTopScrollDetalhesVaga == null) {
            observerStickyTopScrollDetalhesVaga = new window.IntersectionObserver((e) => {
                if (!e[0].isIntersecting) {
                    navbarFixadaDetalheVaga.classList.remove('d-none');
                } else {
                    navbarFixadaDetalheVaga.classList.add('d-none');
                }
            });
        }

        //Se parar de ver o card com os detalhes da vaga, exibe stick top
        observerStickyTopScrollDetalhesVaga.observe(document.querySelector('.btn-candidatarse'));

        containerInscrevaseStick.innerHTML = containerInscrevase.innerHTML;
        containerInscrevaseStick.querySelector('.btn-hideStickTop')?.classList.add('d-none');

        const btn = containerInscrevaseStick.querySelector('.btn-candidatarse');
        const btnCandidatarWhatsApp = containerInscrevaseStick.querySelector('.btn-candidatarse-whatsapp');
        if (btn) {
            btn.classList.add('ajuste-nav-info-vaga-btn-inscrever');
            if (eventListner == 'NaoLogado') {
                btn.addEventListener('click', (e) => {
                    _eventListnerBotaoCandidatarNaoLogado();
                });
            } else {
                if (variasCidades) {
                    btn.addEventListener('click', async (e) => {
                        await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
                        addTrack('Inscricao Vaga', { finalizouCandidatura: false, vagaID: vagaID });
                    });

                } else {
                    btn.addEventListener('click', async (e) => {
                        _confirmarCandidatura();
                    });
                }
            }
        }

        if (btnCandidatarWhatsApp) {
            btnCandidatarWhatsApp.addEventListener('click', (e) => {
                _eventListnerBotaoCandidatarWhatsApp();
            });
        }
    };

    const _atualizarContainerAlerta = evento => {
        const wrapper = document.getElementById('botao-wrapper-alerta');
        if (evento.type == 'alerta-excluido') {
            wrapper.querySelector('h5 b').textContent = i18next.t('AlertaVagasConfigurarAlertaText');
        } else if (evento.type == 'alerta-salvo') {
            wrapper.querySelector('h5 b').textContent = i18next.t('AlertaVagasEditarText');
        }
    }

    const criarBlocoAlertaVagas = async () => {
        const url = `/${CULTURE_EMPREGARE}/Vagas/VerificarAlertaVagas/?vagaCargo=${vagaCargo}`;
        const callbackSucesso = (data) => {
            const vagaDetalhesContainer = document.querySelector("#vaga-detalhes-container");
            const blocoInformacoes = vagaDetalhesContainer?.querySelector(".informacoes");
            const blocoAlertaVagas = blocoInformacoes?.querySelector(".container-alerta-vagas");
            const cardAlertaVagas = blocoAlertaVagas?.querySelector(".card-alerta-vagas");

            if (!isNullOrEmpty(vagaCargo)) {
                if (cardAlertaVagas) {
                    cardAlertaVagas.innerHTML = templateCardAlertaVagas(data.data, vagaCargo, vagaID, vagaCidadesSeparadas, vagaCidadesSeparadasVirgula);



                    const botao = document.getElementById('botao-alerta');
                    if (botao) {
                        new AlertaVaga(botao);

                        const wrapperAlerta = document.getElementById('botao-wrapper-alerta');
                        wrapperAlerta.addEventListener('alerta-salvo', _atualizarContainerAlerta);
                        wrapperAlerta.addEventListener('alerta-excluido', _atualizarContainerAlerta);
                    }
                }
            }
            else
                blocoAlertaVagas?.classList.add('d-none');
        };

        await getFetch(url, callbackSucesso);
    };

    const criarPlayerVideo = async () => {
        const videoContainer = document.getElementById("containerVideo");

        if (!videoContainer) return;

        const playerContainer = videoContainer.querySelector('.player');

        if (playerContainer) {
            let videoUrl = videoContainer.dataset.urlvideo;
            let videoId = videoContainer.dataset.idvideo;

            const imgItem = document.createElement('img');
            imgItem.alt = videoId;

            const iconPlayer = document.createElement('i');
            iconPlayer.classList = "bi bi-play-circle-fill";


            if (videoUrl.includes('yout')) {
                imgItem.src = `https://img.youtube.com/vi/${videoId}/0.jpg`;
            }
            else if (videoUrl.includes('vimeo')) {
                const responseThumb = await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
                if (!responseThumb.ok) {
                    imgItem.src = "";
                }

                const data = await responseThumb.json();

                if (Array.isArray(data) && data.length > 0) {
                    imgItem.src = data[0].thumbnail_large;
                }
            }

            playerContainer.append(imgItem, iconPlayer);

        }

        const _handleVideoClick = function (e) {
            e.currentTarget.removeEventListener('click', _handleVideoClick);

            let urlVideoOriginal = e.currentTarget.dataset.urlvideo;
            let urlVideoToRender = "";

            if (urlVideoOriginal.includes('vimeo')) {
                urlVideoToRender = `${urlVideoOriginal}&autoplay=1`
            } else if (urlVideoOriginal.includes('yout')) {
                urlVideoToRender = `${urlVideoOriginal}?autoplay=1`
            }
            else {
                urlVideoToRender = urlVideoOriginal;
            }

            e.currentTarget.innerHTML = `<iframe src="${urlVideoToRender}" title="${e.currentTarget.dataset.titlevideo}" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        referrerpolicy="strict-origin-when-cross-origin" enablejsapi="0"
                                        allowfullscreen></iframe>`;
        };

        videoContainer.addEventListener('click', _handleVideoClick);
    }

    const _criarBotaoVoltar = () => {
        var urlAnterior = document.referrer;
        var botaoVoltar = document.getElementById("botao-voltar");

        if (botaoVoltar && urlAnterior && urlAnterior.toLowerCase().includes('editais')) {
            var urlEditais = botaoVoltar.dataset.urlEditais;
            botaoVoltar.href = urlEditais;

            var novoTexto = botaoVoltar.dataset.voltarEditais;
            var smallTag = botaoVoltar.querySelector('small');
            var icone = smallTag.querySelector('i');

            if (smallTag && novoTexto && icone) {
                smallTag.innerHTML = icone.outerHTML + ' ' + novoTexto;
            }
        }
    }

    const criarBlocoFanPage = async () => {
        const url = `/${CULTURE_EMPREGARE}/FanPage/DetalhesJson?empresaID=${empresaID}`;


        const callbackSucesso = (data) => {
            const vagaDetalhesContainer = document.querySelector("#vaga-detalhes-container");
            const blocoInformacoes = vagaDetalhesContainer?.querySelector(".informacoes");
            const blocoInfoFanpage = blocoInformacoes?.querySelector(".container-info-fanpage");
            const cardInfoFanpage = blocoInfoFanpage?.querySelector(".card-info-fanpage");

            if (!isNullOrEmpty(empresaID)) {
                if (cardInfoFanpage) {
                    cardInfoFanpage.innerHTML = templateCardInfoFanpage(data.data, empresaID);

                    if (data.data.tipoArquivo.toLowerCase() === 'video') {
                        criarPlayerVideo();
                    }
                }
            }
            else {
                blocoInfoFanpage?.classList.add('d-none');
            }
        };

        await getFetch(url, callbackSucesso);
    }

    const init = function () {
        _criarBotaoVoltar();
        banner.renderizar('banner-detalhes-vaga', localBanner.VAGA_DETALHES);

        inicializarInternacionalizacao();

        Confirm.init({
            className: "confirm-empregare",
            titleColor: "#EA1F1F",
            okButtonColor: "#f8f8f8",
            okButtonBackground: "#EA1F1F",
            cancelButtonColor: "#f8f8f8",
        });
        _definirOrigemCadastro();
        const btnModalCompartilhar = document.querySelectorAll('.btn-abrir-modal-divulgacao');
        btnModalCompartilhar.forEach(el => el.addEventListener('click', () => {
            _modalCompartilhar();
        }));

        const btnModalDenunciar = document.querySelectorAll('.btn-abrir-modal-denunciar');
        btnModalDenunciar.forEach(el => el.addEventListener('click', () => {
            _modalDenunciar();
        }));


        _modalCompartilharCopiarLink();

        document.querySelectorAll('.info-cega').forEach(el => el.addEventListener('click', () => {
            const tabParaAbrir = el.dataset.tab;
            _modalSelecaoCega(tabParaAbrir);
        }));

        document.getElementById('btn-login-vaga').addEventListener('click', () => {
            _modalCandidatarLogin();
        });
        document.getElementById('btn-cadastrar-vaga').addEventListener('click', () => {
            _redirecionarNovoCadastro();
        });
        document.getElementById('form-confirmar-inscricao').addEventListener('submit', (e) => {
            _confirmarCandidatura();
            e.preventDefault();
        });

        document.getElementById('candidatura-whatsapp-web').addEventListener('click', () => {
            _confirmarCandidaturaBot();
        });

        _botaoCandidatar();
        criarBlocoAlertaVagas();

        let possuiDadosSolicitante = document.getElementById('PossuiDadosSolicititante').value;
        let tipoArquivoSolicitante = document.getElementById('SolicitanteTipoArquivo').value;
        if (possuiDadosSolicitante.toLowerCase() == "true") {
            if (tipoArquivoSolicitante.toLowerCase() == "video") {
                criarPlayerVideo();
            }
            else if (tipoArquivoSolicitante == "UsarInfoFanPage" && !isNullOrEmpty(empresaID)) {
                criarBlocoFanPage()
            }
        }

    };

    return init();
};

vagaDetalhes();

window.addEventListener('pageshow', function (event) {
    // A propriedade 'persisted' será verdadeira se a página foi carregada do bfcache.
    console.log({ persisted: event.persisted });
    if (event.persisted) {
        // Esconde o loading caso o usuário tenha voltado para a página usando o botão "voltar" do navegador.
        loadFullPage.esconder();
    }
});